import { ETextColor } from '@NGUtils/enums';
import { EPromptType } from '@shared/cli/components/Prompt/Prompt.enum';
import {
	IHintsButtonState,
	INewQuestPrompt,
	INextButtonState,
	IVerifyButtonState
} from './devhubSingleQuestStore.types';

const CURRENT_QUEST_INDEX_KEY = 'current-quest-index';
const QUEST_PROMPT_KEY = 'quest-prompt';

const defaultCurrentQuestIndex = {
	quest: undefined,
	index: 0
};

enum EQuestPromptsKeys {
	resultLoading = 'resultLoading',
	questAlreadyValidated = 'questAlreadyValidated',
	questStarted = 'questStarted',
	questFinished = 'questFinished'
}

enum EQuestPromptsFnKeys {
	campaignCompleted = 'campaignCompleted',
	ctfCheckIfContractIsHacked = 'ctfCheckIfContractIsHacked',
	ctfContractIsHacked = 'ctfContractIsHacked',
	ctfContractIsNotHacked = 'ctfContractIsNotHacked',
	questError = 'questError',
	deployingContract = 'deployingContract',
	deployingContractError = 'deployingContractError',
	deployingContractSuccess = 'deployingContractSuccess',
	deployingContractFailedWithMessage = 'deployingContractFailedWithMessage'
}

export const promptChars = {
	check: '✓ ',
	cross: '✗ '
};

const questPrompts: { [key in EQuestPromptsKeys]: INewQuestPrompt } = {
	resultLoading: {
		message: 'Verifying your submission...',
		type: EPromptType.loading
	},
	questAlreadyValidated: {
		message: 'You have already validated this quest!',
		type: EPromptType.neutral,
		color: ETextColor.success,
		isEnd: true
	},
	questStarted: {
		message: 'Quest started!',
		type: EPromptType.neutral,
		isEnd: true
	},
	questFinished: {
		message: 'Quest Completed!',
		type: EPromptType.neutral,
		color: ETextColor.success,
		isEnd: true
	}
};

const questPromptsFn: { [key in EQuestPromptsFnKeys]: (...args: any[]) => INewQuestPrompt } = {
	ctfCheckIfContractIsHacked: (contractName: string | undefined): INewQuestPrompt => ({
		message: `Verifying${contractName ? ` ${contractName}` : ''} contract...`,
		type: EPromptType.loading
	}),
	ctfContractIsHacked: (contractName: string | undefined): INewQuestPrompt => ({
		message: `${promptChars.check}${contractName} contract is hacked!`,
		type: EPromptType.success,
		color: ETextColor.success,
		isEnd: true
	}),
	ctfContractIsNotHacked: (contractName: string | undefined): INewQuestPrompt => ({
		message: `${promptChars.cross}${contractName} contract is not hacked!`,
		type: EPromptType.error,
		color: ETextColor.error,
		isEnd: true
	}),
	questError: (error: string): INewQuestPrompt => ({
		message: `${error}`,
		type: EPromptType.error,
		color: ETextColor.error,
		isEnd: true
	}),
	campaignCompleted: (campaignName: string | undefined): INewQuestPrompt => ({
		message: `${campaignName ? `${campaignName} c` : 'C'}ampaign completed!`,
		type: EPromptType.neutral,
		color: ETextColor.success,
		isEnd: true
	}),
	deployingContract: (contractName: string | undefined): INewQuestPrompt => ({
		message: `Deploying${contractName ? ` ${contractName}` : ''} contract...`,
		type: EPromptType.loading
	}),
	deployingContractError: (contractName: string | undefined): INewQuestPrompt => ({
		message: `Error while deploying${contractName ? ` ${contractName}` : ''} contract!`,
		type: EPromptType.error,
		color: ETextColor.error,
		isEnd: true
	}),
	deployingContractFailedWithMessage: (message: string): INewQuestPrompt => ({
		message: `${message}`,
		type: EPromptType.error,
		color: ETextColor.error,
		isEnd: true
	}),
	deployingContractSuccess: (contractName: string | undefined, contractAddress: string): INewQuestPrompt => ({
		message: `${promptChars.check}${contractName} contract deployed at ${contractAddress}!`,
		type: EPromptType.success,
		color: ETextColor.success,
		isEnd: true
	})
};

const SUBMIT_QUIZ_RATE_LIMIT_KEY = 'rateLimitEndTimestamp';

const defaultVerifyButtonState: IVerifyButtonState = {
	isHidden: true,
	isVerifying: false,
	isDisabled: true,
	isValidated: false,
	isAPartToVerify: false
};

const defaultHintsButtonState: IHintsButtonState = {
	isHidden: true,
	isDisabled: true
};

const defaultNextButtonState: INextButtonState = {
	isDisabled: true
};

export {
	CURRENT_QUEST_INDEX_KEY,
	QUEST_PROMPT_KEY,
	SUBMIT_QUIZ_RATE_LIMIT_KEY,
	defaultCurrentQuestIndex,
	defaultHintsButtonState,
	defaultNextButtonState,
	defaultVerifyButtonState,
	questPrompts,
	questPromptsFn
};
